"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _functions = require("../../util/functions");
require("rc-checkbox/assets/index.css");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
require("react-dropdown/style.css");
require("./DownloadPdf.css");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCircleNotch);
const reactDropdownStyles = {
  control: (styles, _ref) => {
    let {
      data,
      isDisabled,
      isFocused,
      isSelected
    } = _ref;
    return {
      ...styles,
      border: 0,
      // This line disable the blue border
      boxShadow: 0,
      fontSize: 16,
      color: '#050139',
      '&:hover': {
        border: 0
      }
    };
  },
  singleValue: () => ({
    color: '#050139',
    fontSize: 16
  }),
  placeholder: () => ({
    color: '#BDC2C6'
  }),
  dropdownIndicator: () => ({
    color: '#596770',
    paddingTop: '4px'
  }),
  indicatorSeparator: () => null,
  option: (styles, _ref2) => {
    let {
      data,
      isDisabled,
      isFocused,
      isSelected
    } = _ref2;
    return {
      ...styles,
      marginTop: '0px',
      '&:hover': {
        color: '#FFF',
        cursor: 'pointer'
      },
      '&:isSelected': {
        color: '#FFF'
      },
      '&:isFocused': {
        color: '#FFF'
      }
    };
  }
};
class DownloadPdf extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectDropdown = this.handleSelectDropdown.bind(this);
    this.handleDropzoneChange = this.handleDropzoneChange.bind(this);
    this.handleEnterPress = this.handleEnterPress.bind(this);
    this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
    this.handleShowLogo = this.handleShowLogo.bind(this);
    this.state = {
      config: null,
      waitingForPdf: false,
      userLogo: null,
      openModal: this.props.openModalOnLoad,
      errorGeneratingPdf: false,
      showLogo: true,
      accentColor: '#05A9B1'
    };

    // Create ref for the accent styles
    this.styleRef = /*#__PURE__*/_react.default.createRef();
  }

  // Set up the state to have default values for the dynamically loaded inputs
  componentDidMount() {
    const styles = getComputedStyle(this.styleRef.current);
    this.setState({
      accentColor: (0, _functions.convertRgbToHex)(styles.color)
    });

    // Get the config for the app
    this.getConfig();
  }

  /********************************************* 
   * Async methods for api interactions
  **********************************************/

  async getConfig() {
    const {
      dataspanApiUrl,
      token,
      configId
    } = this.props;
    if (token !== undefined) {
      // Get the document config from Dataspan
      const requestId = {
        method: 'GET',
        url: "".concat(dataspanApiUrl, "/pdf/").concat(configId, "/")
      };
      return (0, _axios.default)(requestId).then(d => {
        if (d.status === 404) {
          return;
        } else {
          return d.data;
        }
      }).then(data => {
        // If the ID exists then get the logo itself
        if (data.id === configId) {
          // Store the config for later user (on a reinitialize)
          this.setState({
            config: data
          });
          this.initializeInputs(data);

          // // Get the logo once the config has been loaded
          this.getUserLogo();
        }
      }).catch(error => {
        console.error(error);
      });
    }
  }
  async getUserLogo() {
    const {
      dpdApiUrl,
      token,
      clientEmail,
      isAnonymous
    } = this.props;
    if (token !== 'undefined' && clientEmail && !isAnonymous) {
      // Get the client's logo id from DPD - DPD stores and handles all client logos rather
      // than DataSpan
      const requestId = {
        method: 'GET',
        url: "".concat(dpdApiUrl, "/api/image/logo/").concat(clientEmail, "/id/"),
        headers: {
          Authorization: token && "Token ".concat(token)
        }
      };
      return (0, _axios.default)(requestId).then(d => {
        if (d.status === 404) {
          return;
        } else {
          return d.data;
        }
      }).then(data => {
        // If the ID exists then get the logo itself
        if (data.id) {
          this.loadUserLogo(data.id);
        }
      }).catch(error => {
        console.error(error);
      });
    }
  }

  // Load the logo into state
  loadUserLogo(id) {
    const {
      dpdApiUrl
    } = this.props;

    // Put together the URL to the logo
    const imageUrl = dpdApiUrl + '/api/image/logo/lookup/?id=' + id;

    // If there any logo inputs then update with the latest
    // url for the user
    const inputsWithLogo = this.state.inputs.map(input => {
      let updatedInput = Object.assign({}, input);
      if (updatedInput.inputType === 'logo') {
        updatedInput.value = imageUrl;
      }
      return updatedInput;
    });

    // Save the logo
    this.setState({
      userLogo: {
        'imageId': id,
        'imageUrl': imageUrl
      },
      inputs: inputsWithLogo
    });
  }

  // Save a user's logo using DPD
  async saveUserLogo(fileToSave) {
    const {
      dpdApiUrl,
      token,
      clientEmail,
      isAnonymous
    } = this.props;
    if (token !== 'undefined' && clientEmail || isAnonymous) {
      let formData = new FormData();
      formData.append('imageData', fileToSave);
      formData.append('clientEmail', clientEmail);
      formData.append('fileName', fileToSave.name);
      let request;
      if (!isAnonymous) {
        request = {
          method: 'POST',
          url: "".concat(dpdApiUrl, "/api/image/logo/"),
          data: formData,
          headers: {
            Authorization: token && "Token ".concat(token)
          }
        };
      } else {
        request = {
          method: 'POST',
          url: "".concat(dpdApiUrl, "/api/image/logo/add_anon/"),
          data: formData
        };
      }
      return (0, _axios.default)(request).then(d => {
        if (d.status === 404) {
          return;
        } else {
          return d.data;
        }
      }).then(data => {
        // Save the new id if the post was successful
        if (data.id) {
          this.loadUserLogo(data.id);
        }
      }).catch(error => {
        console.error(error);
      });
    }
  }
  async generatePdf(documentProperties, adhocInputs, outputName) {
    const {
      dataspanApiUrl,
      token,
      clientEmail,
      isAnonymous,
      configId
    } = this.props;

    // Don't send in the input if its value is empty. Divide percentage values by 100
    const inputs = adhocInputs.filter(input => input.value !== undefined && input.value !== null && input.value !== '').map(input => {
      return {
        'name': input.name,
        'type': input.type,
        'value': input.inputType === 'percentage' ? parseFloat(input.value) / 100 : input.value
      };
    });
    let body = {
      clientEmail: clientEmail,
      teamSiteId: documentProperties.teamSiteId,
      libraryContentVersionId: documentProperties.libraryContentVersionId,
      outputName: outputName,
      adhocInputs: inputs,
      id: configId
    };
    if (token !== 'undefined' && clientEmail || isAnonymous) {
      let request;

      // If this is an anonymous generation then don't add the token
      if (!isAnonymous) {
        request = {
          method: 'POST',
          responseType: 'blob',
          url: "".concat(dataspanApiUrl, "/pdf/generate/"),
          data: body,
          headers: {
            'Content-Type': 'application/json',
            Authorization: token && "Token ".concat(token)
          }
        };
      } else {
        request = {
          method: 'POST',
          responseType: 'blob',
          url: "".concat(dataspanApiUrl, "/pdf/generate_with_id/"),
          data: body,
          headers: {
            'Content-Type': 'application/json'
          }
        };
      }
      return (0, _axios.default)(request).then(response => {
        // If the generate has been cancelled then ignore the save
        if (this.state.waitingForPdf) {
          //1. Create a Blob from the PDF Stream
          const file = new Blob([response.data], {
            type: 'application/pdf'
          });
          // 2. Create blob link to download
          const url = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.setAttribute('download', "".concat(outputName, ".pdf"));

          // 3. Check if the user agent is not Chrome on mobile, need to manually open tab if so
          if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
            // window event not working here
            document.location = link.href;
          } else {
            // 4. Force a mouse click and then remove the link
            let evt = new MouseEvent('click', {
              'view': window,
              'bubbles': true,
              'cancelable': false
            });
            link.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(link.href);
          }

          // // 3. Append to html page
          // document.body.appendChild(link);
          // // 4. Force download
          // link.click();
          // // 5. Clean up and remove the link
          // setTimeout(function(){ link.parentNode.removeChild(link); }, 3000);

          this.handleCloseModal();
        }
      }).catch(error => {
        console.error(error);

        // Set the error
        this.setState({
          errorGeneratingPdf: true
        });
        // this.handleCloseModal();
      });
    }
  }

  /********************************************* 
  * Input methods and change handlers
  **********************************************/

  // Wipe out the inputs and set back to original defaults
  initializeInputs(config) {
    if (config && config.adhocInputs) {
      // Initialize the input 
      const initializedInputs = config.adhocInputs.map(input => {
        let updatedInput = Object.assign({}, input);
        if (updatedInput.inputType === 'logo') {
          updatedInput.value = this.state.userLogo ? this.state.userLogo.imageUrl : null;
        }
        return updatedInput;
      });
      this.setState({
        docConfig: config,
        documentProperties: {
          teamSiteId: config.teamSiteId,
          libraryContentVersionId: config.libraryContentVersionId,
          outputName: config.outputName,
          contentName: config.contentName
        },
        inputs: initializedInputs
      });

      // Update the inputs with the passed in Adhoc inputs (if the calling app wants to 'hard code' inputs)            
      this.updatePropAdhocInputs(config);
    }
  }

  // Update all inputs with the passed into Adhoc Inputs (via prop adhocInput).
  updatePropAdhocInputs(config) {
    const {
      adhocInputs,
      clientEmail
    } = this.props;
    if (config && config.adhocInputs && adhocInputs) {
      let num_footnotes = 0;

      // Initialize the input 
      const updatedInputs = config.adhocInputs.map(input => {
        let updatedInput = Object.assign({}, input);

        // Ensure the logo is always added back from state. This could be overriden below if necessary
        if (updatedInput.inputType === 'logo') {
          updatedInput.value = this.state.userLogo ? this.state.userLogo.imageUrl : null;
        }

        // Add the email address of client to fields as necessary
        if (updatedInput.inputType === 'clientEmail') {
          updatedInput.value = clientEmail ? clientEmail : null;
        }

        // Add a footnote number to each input that has a footnote
        if (updatedInput.footnote) {
          num_footnotes = num_footnotes + 1;
          updatedInput.footnoteNumber = num_footnotes;
        }
        const matchingAdhocInput = adhocInputs.filter(adhocInput => adhocInput.name === updatedInput.name);

        // Set the value of the input to the incoming prop adhoc input value
        if (matchingAdhocInput.length === 1 && updatedInput.inputType !== 'dropdown') {
          updatedInput.value = matchingAdhocInput[0].value;
          updatedInput.label = matchingAdhocInput[0].label ? matchingAdhocInput[0].label : updatedInput.label;

          // If the input is a dropdown then set the options
        } else if (matchingAdhocInput.length === 1 && updatedInput.inputType === 'dropdown') {
          // Update the options if passed in as props
          if (matchingAdhocInput[0].options) {
            updatedInput.options = matchingAdhocInput[0].options;
          }

          // If a value was passed in, the caller wants a specific option to be highlighted, make sure
          // it matches one of the options.
          if (matchingAdhocInput[0].value) {
            const matchingOption = updatedInput.options.filter(option => option.value === matchingAdhocInput[0].value);
            if (matchingOption.length === 1) {
              updatedInput.value = matchingOption[0].value;
              updatedInput.label = matchingOption[0].label;
            }
          }
        }
        return updatedInput;
      });
      this.setState({
        inputs: updatedInputs
      });
    }
  }

  // Iterate the inputs and ensure all are filled in
  allInputsValid() {
    const {
      percentageMin,
      percentageMax
    } = this.props;
    const {
      inputs
    } = this.state;
    let allComplete = false;
    if (inputs) {
      allComplete = true;

      // Loop over each input and check the values
      inputs.forEach(input => {
        if ((input.optional === null || input.optional === false) && (input.value === undefined || input.value === null || input.value === '') ||
        // Check that percentage fields are within limits
        input.inputType === 'percentage' && (input.value < percentageMin || input.value > percentageMax)) {
          allComplete = false;
        }
      });
    }
    return allComplete;
  }

  // Handle open of modal
  handleOpenModal() {
    // Submit right away if all the inputs are there and the app hasn't
    // been overriden to always show the modal
    if (this.allInputsValid() && this.props.submitOnLoad) {
      this.handleSubmit();
    } else {
      this.initializeInputs(this.state.config);
      this.setState({
        openModal: true
      });
    }
  }

  // Handle close of modal
  handleCloseModal() {
    const {
      callbackOnClose
    } = this.props;
    this.setState({
      openModal: false,
      waitingForPdf: false,
      errorGeneratingPdf: false
    });

    // If a callback is provided then call it
    if (callbackOnClose) {
      callbackOnClose();
    }
    this.initializeInputs(this.state.config);
  }

  // Handle all updates
  updateInput(name, value, label) {
    // Update the input
    const updatedInputs = this.state.inputs.map(input => {
      let updatedInput = Object.assign({}, input);
      if (updatedInput.name === name) {
        updatedInput.value = value;
        updatedInput.label = label;
      }
      return updatedInput;
    });
    this.setState({
      inputs: updatedInputs
    });
  }

  // Update the state with changes to inputs
  handleChange(event) {
    this.updateInput(event.target.name, event.target.value, event.target.value);
  }

  // Update the state with changes to checkbox inputs
  handleChangeCheckBox(name, value) {
    this.updateInput(name, value, value);
  }

  // Handle events from drop downs
  handleSelectDropdown(name, value, label) {
    this.updateInput(name, value, label);
  }

  // Handle events from dropzones
  handleDropzoneChange(input, acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.saveUserLogo(acceptedFiles[0]);
    }
  }

  // Handle showing or hiding the logo
  handleShowLogo() {
    // If there is a logo then update the value (based on whether the user wants to show/hide it)
    if (this.state.userLogo) {
      const imageUrl = this.state.userLogo.imageUrl;

      // Turn on or off the logo inputs
      const inputsWithLogo = this.state.inputs.map(input => {
        let updatedInput = Object.assign({}, input);

        // showLogo hasn't been updated yet so check the opposite to see if it needs adding or removing
        if (updatedInput.inputType === 'logo' && !this.state.showLogo) {
          updatedInput.value = imageUrl;
        } else if (updatedInput.inputType === 'logo' && this.state.showLogo) {
          updatedInput.value = null;
        }
        return updatedInput;
      });
      this.setState({
        inputs: inputsWithLogo,
        showLogo: !this.state.showLogo
      });
    } else {
      this.setState({
        showLogo: !this.state.showLogo
      });
    }
  }

  // Handle enter press (if button enabled)
  handleEnterPress(event) {
    if (event.keyCode === 13 && this.allInputsValid()) {
      this.handleSubmit();
    }
  }

  // Submit the inputs to pdf generator
  handleSubmit() {
    const {
      inputs,
      documentProperties
    } = this.state;

    // Update the output name if necessary
    let outputName = documentProperties.outputName;
    inputs.forEach(input => {
      outputName = outputName.replace("[[" + input.name + "]]", input.label ? input.label : '');
    });

    // Close the model and show the waiting indicator
    this.setState({
      openModal: false,
      waitingForPdf: true
    });

    // Generate the pdf
    this.generatePdf(documentProperties, inputs, outputName);

    // Reset all fields
    this.initializeInputs(this.state.config);
  }
  renderFootnotes() {
    const {
      inputs
    } = this.state;
    if (!inputs || !Array.isArray(inputs)) {
      return null;
    }
    const footnotes = inputs.map(input => {
      return input.footnote ? /*#__PURE__*/_react.default.createElement("div", {
        className: "footnote-text",
        key: input.footnoteNumber
      }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber), input.footnote) : null;
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "footnote-area"
    }, footnotes);
  }
  render() {
    const {
      downloadButtonText,
      cancelButtonText,
      modalTitleText,
      waitingMessageText,
      initialButtonText,
      errorGeneratingPdfText,
      openModalOnLoad,
      closeWindowText,
      showCloseText,
      percentageMin,
      percentageMax
    } = this.props;
    const {
      waitingForPdf,
      inputs,
      openModal,
      errorGeneratingPdf,
      showLogo,
      accentColor
    } = this.state;
    const inputFields = inputs ? inputs.map(input => {
      switch (input.inputType) {
        case 'text':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "text-row"
          }, /*#__PURE__*/_react.default.createElement("input", {
            className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
            type: input.inputType,
            name: input.name,
            value: input.value ? input.value : '',
            onChange: this.handleChange,
            placeholder: input.placeholder
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber))));
        case 'textarea':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "text-row"
          }, /*#__PURE__*/_react.default.createElement("textarea", {
            rows: "4",
            className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
            type: input.type,
            name: input.name,
            value: input.value ? input.value : '',
            onChange: this.handleChange,
            placeholder: input.placeholder
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber))));
        case 'dropdown':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "text-row"
          }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
            className: (0, _classnames.default)('wt-dropdown', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
            placeholder: input.placeholder,
            onChange: selectedItem => {
              this.handleSelectDropdown(input.name, selectedItem.value, selectedItem.label);
            },
            styles: reactDropdownStyles,
            theme: theme => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: accentColor,
                primary: accentColor
              }
            }),
            options: input.options,
            isMulti: false,
            value: input.value ? {
              'value': input.value,
              'label': input.label
            } : null
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber))));
        case 'logo':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "switch-label"
          }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
            onChange: this.handleShowLogo,
            checked: showLogo,
            handleDiameter: 21,
            width: 51,
            height: 25,
            uncheckedIcon: false,
            checkedIcon: false
            // disabled={saveInProgress}
            ,

            offColor: "#BDC2C6",
            onColor: accentColor,
            activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "logo-label"
          }, /*#__PURE__*/_react.default.createElement("label", null, "\xA0 Display your logo"), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber)))), showLogo ? /*#__PURE__*/_react.default.createElement("div", {
            className: (0, _classnames.default)('image-row', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '', input.value === null && input.optional === true ? 'empty' : '')
          }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
            onDrop: acceptedFiles => {
              console.log(acceptedFiles);
              this.handleDropzoneChange(input, acceptedFiles);
            }
          }, _ref3 => {
            let {
              getRootProps,
              getInputProps
            } = _ref3;
            return /*#__PURE__*/_react.default.createElement("section", {
              className: (0, _classnames.default)('dropzone-section')
            }, /*#__PURE__*/_react.default.createElement("div", _extends({}, getRootProps(), {
              className: (0, _classnames.default)('dropzone', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '')
            }), /*#__PURE__*/_react.default.createElement("input", _extends({}, getInputProps(), {
              accept: "image/png, image/jpeg, image/gif"
            })), /*#__PURE__*/_react.default.createElement("p", null, input.placeholder)));
          }), input.value ? /*#__PURE__*/_react.default.createElement("div", {
            className: "image-preview"
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: input.value,
            alt: "logo"
          })) : null) : null);
        case 'checkbox':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "switch-label"
          }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
            onChange: this.handleChangeCheckBox.bind(this, input.name, !input.value),
            checked: input.value,
            handleDiameter: 21,
            width: 51,
            height: 25,
            uncheckedIcon: false,
            checkedIcon: false
            // disabled={saveInProgress}
            ,

            offColor: "#BDC2C6",
            onColor: accentColor,
            activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
          }), /*#__PURE__*/_react.default.createElement("label", null, "\xA0 ", input.placeholder), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber))));
        case 'percentage':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "input-row",
            key: input.name
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "percentage"
          }, /*#__PURE__*/_react.default.createElement("input", {
            className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) || input.value < percentageMin || input.value > percentageMax ? 'invalid' : ''),
            type: "number",
            min: percentageMin,
            max: percentageMax,
            step: "0.01",
            name: input.name,
            value: input.value ? input.value : '',
            onChange: this.handleChange
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "percent"
          }, "\xA0%"), /*#__PURE__*/_react.default.createElement("div", {
            className: "placeholder"
          }, input.placeholder), /*#__PURE__*/_react.default.createElement("div", {
            className: "footnote"
          }, /*#__PURE__*/_react.default.createElement("sup", null, input.footnoteNumber))));
        default:
          return null;
      }
    }) : null;
    return /*#__PURE__*/(
      // Show the button for download
      _react.default.createElement("div", {
        className: "download-pdf"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "accent-color",
        ref: this.styleRef
      }), openModalOnLoad === false ? /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleOpenModal
      }, initialButtonText) : null,
      //  Show configuration modal
      openModal && waitingForPdf === false ? /*#__PURE__*/_react.default.createElement("div", {
        onKeyDown: this.handleEnterPress
      }, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
        open: openModal === true,
        onClose: this.handleCloseModal,
        showCloseIcon: false,
        focusTrapped: false,
        classNames: {
          overlay: 'modal-overlay',
          modal: 'customize-pdf'
        },
        closeOnOverlayClick: true // Stops user from closing when clicking off modal
        ,

        closeOnEsc: true,
        center: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "customize-pdf-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-title"
      }, modalTitleText), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-values"
      }, inputFields), this.renderFootnotes(), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-buttons"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-spot"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleSubmit,
        disabled: !this.allInputsValid()
      }, downloadButtonText)), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-spot"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleCloseModal
      }, cancelButtonText)))))))

      //  Show waiting modal if pdf generation is in progress
      : waitingForPdf && openModal === false ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
        open: waitingForPdf === true,
        showCloseIcon: false,
        onClose: this.handleCloseModal,
        focusTrapped: false,
        classNames: {
          overlay: 'modal-overlay',
          modal: 'waiting-for-pdf'
        },
        closeOnOverlayClick: true // Stops user from closing when clicking off modal
        ,

        closeOnEsc: true,
        center: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "waiting-for-pdf-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "waiting-for-pdf-container-message"
      }, errorGeneratingPdf ? '' : waitingMessageText), /*#__PURE__*/_react.default.createElement("div", {
        className: "waiting-for-pdf-container-loading"
      }, errorGeneratingPdf ? /*#__PURE__*/_react.default.createElement("p", null, errorGeneratingPdfText) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: "circle-notch",
        size: "3x",
        className: "waiting-icon",
        spin: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "waiting-for-pdf-container-cancel"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleCloseModal
      }, cancelButtonText))))) : null, openModalOnLoad === true && openModal === false && waitingForPdf === false && showCloseText === true ? /*#__PURE__*/_react.default.createElement("div", {
        className: "close-window"
      }, closeWindowText) : null)
    );
  }
}
exports.default = DownloadPdf;
_defineProperty(DownloadPdf, "defaultProps", {
  initialButtonText: 'Download',
  downloadButtonText: 'Download',
  cancelButtonText: 'Cancel',
  modalTitleText: 'Customize Your Document',
  previewText: 'Preview',
  waitingMessageText: 'Please wait while your document is generated',
  closeWindowText: 'You can now close this window',
  token: '',
  dataspanApiUrl: 'https://dataspanapi.wisdomtree.com',
  dpdApiUrl: 'https://dpd.wisdomtree.com',
  clientEmail: '',
  configId: '',
  adhocInputs: null,
  errorGeneratingPdfText: 'There was an error generating your document. Please try again later.',
  submitOnLoad: true,
  isAnonymous: false,
  openModalOnLoad: false,
  showCloseText: true,
  callbackOnClose: null,
  percentageMin: 0,
  percentageMax: 10
});
DownloadPdf.propTypes = {
  /**
   * Text for the initial button added to any app
   */
  initialButtonText: _propTypes.default.string,
  /**
   * Text for the download button
   */
  downloadButtonText: _propTypes.default.string,
  /**
   * Text for the cancel button
   */
  cancelButtonText: _propTypes.default.string,
  /**
   * Text for the title of the customize modal
   */
  modalTitleText: _propTypes.default.string,
  /**
   * Waiting text when the pdf is generating
   */
  waitingMessageText: _propTypes.default.string,
  /**
   * Text for when the window closes
   */
  closeWindowText: _propTypes.default.string,
  /**
   * Token for the DPD/Dataspan APIs (required)
   */
  token: _propTypes.default.string.isRequired,
  /**
   * ID of the Config for the Seismic document. Used to retrieve the config
   * when using the DownloadPdf component
   */
  configId: _propTypes.default.string,
  /**
   * Client Email of the user generating the pdf (required)
   */
  clientEmail: _propTypes.default.string.isRequired,
  /**
   * Dataspan API url
   */
  dataspanApiUrl: _propTypes.default.string,
  /**
   * DPD API url
   */
  dpdApiUrl: _propTypes.default.string,
  /**
   * Error message for pdf generation failure
   */
  errorGeneratingPdfText: _propTypes.default.string,
  /**
   * Optional array of adhoc input values in the form:
   * [{
   *   "name":"family",
   *   "type":"string",
   *   "value":"WisdomTree"
   *  }]
   */
  adhocInputs: _propTypes.default.array,
  /**
   * If you want to force the modal to open then set this prop to false (even if all inputs
   * are satisfied the model will open)
   */
  submitOnLoad: _propTypes.default.bool,
  /**
   * Set to true if the component is to be used anonymously - we don't have a token to 
   * authorize against Dataspan/DPD
   */
  isAnonymous: _propTypes.default.bool,
  /**
   * Open the modal directly and don't show the button
   */
  openModalOnLoad: _propTypes.default.bool,
  /**
   * Show close text when going straight to modal. Only useful if `openModalOnLoad` is set to true
   */
  showCloseText: _propTypes.default.bool,
  /**
   * Optional callback called when modal closes
   */
  callbackOnClose: _propTypes.default.func,
  /**
   * Optional percentage field min
   */
  percentageMin: _propTypes.default.number,
  /**
   * Optional percentage field max
   */
  percentageMax: _propTypes.default.number
};